export default __webpack_public_path__ + "static/article-where-to-travel-328f6a317bba871b159f7b57f263eec4.jpg";